export const navigateToAccount = (): void => {
  window.location.hash = '#account'
}
